import { render } from "./LwChip.vue?vue&type=template&id=ebb7a8bc&scoped=true"
import script from "./LwChip.vue?vue&type=script&lang=js"
export * from "./LwChip.vue?vue&type=script&lang=js"

import "./LwChip.vue?vue&type=style&index=0&id=ebb7a8bc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb7a8bc"]])

export default __exports__